import styled, { css } from 'styled-components'
import Flex from 'src/components/Layout/Flex/Flex'
import MaxWidthWrapper from 'src/components/Layout/MaxWidthWrapper/MaxWidthWrapper'
import { FontStyle } from '../../../components/Core/Typography/Font/Font.styles'

import { MainContentWrapperProps } from './types'
import { FormFooterActionsRight } from 'src/components/Organisms/Form/Form.styles'

export const Content = styled(Flex)`
  width: 100vw;
  position: relative;
`
export const PageHeaderSection = styled(MaxWidthWrapper)`
  border-bottom: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  padding-top: 40px;
  padding-bottom: 24px;
  margin-bottom: 40px;
`

export const PageHeader = styled('div')`
  color: ${props => props.theme.colors.main.dark};
`

export const SubTitle = styled(FontStyle).attrs({
  tag: 'h6',
})`
  margin-top: 8px;
  letter-spacing: 0.12px;
`

export const MainContentWrapper = styled(Flex)<MainContentWrapperProps>`
  display: ${props => props.show ? 'flex' : 'none'};
  width: 100%;

  td {
    word-break: break-word;
  }

    ${props => props.disableButtons && css`

      h5 + div, h5 + div + div {
        cursor: not-allowed;
      }
      
      input, button, table {
        background-color: ${props => props.theme.colors.shades.neutral[0]};
        pointer-events: none;
      }

      table svg path {
        fill: ${props => props.theme.colors.shades.neutral[5]};
      }

     form {
      cursor: not-allowed;

      div[aria-haspopup="listbox"], textarea, input[type="file"] + div {
        background-color: ${props => props.theme.colors.shades.neutral[0]};
      }

      label, div[aria-haspopup="listbox"], table, td, input[type="file"] + div  {
        pointer-events: none;
      }

      input[type="file"] + div label p {
        color: ${props => props.theme.colors.main.ultraViolet};
      }

      label > a {
        pointer-events: auto;
      }

      input[type="radio"]:checked {
        border: 6px solid ${props => props.theme.colors.shades.neutral[5]};
      }

      label[version="1"] > input[type="checkbox"] + span[version="1"] {
        background-color: ${props => props.theme.colors.shades.neutral[1]};
        pointer-events: none;
      }

      svg path {
        fill: ${props => props.theme.colors.shades.neutral[5]};
      }
      
      ${FormFooterActionsRight} {
        button {
          display: none;
        }
      }
    }
  `}
`
